export class NodeJSUtil {
    /**
     * Return true if the code is run in a NodeJS Environment
     */
    static isNode() {
        return typeof process !== 'undefined';
    }
    static getEnvVariable(variableName) {
        return NodeJSUtil.isNode() && process.env ? process.env[variableName] : undefined;
    }
    static getNodeEnv() {
        return NodeJSUtil.getEnvVariable('NODE_ENV');
    }
}
